<template>
  <Panel class="intro-y" :title="$t('text.customerInfoDependentCustomers')">
    <div
      v-for="(contact, index) in customer.emergencyContacts"
      :key="index"
      class="flex flex-col sm:flex-row sm:items-center"
      :class="{ 'mt-5': index > 0 }"
    >
      <div class="mr-auto">
        <div class="text-gray-600">{{ contact.name }}</div>
      </div>
      <div class="flex items-center">
        <div class="font-medium">{{ contact.phone }}</div>
        <Button @click="onSearch(contact.phone)" :disabled="isLoading">
          <EyeIcon class="h-5 w-5 text-gray-600" />
        </Button>
      </div>
    </div>

    <CustomerSearchContactsResultModal :modal-id="modalId" :list="customerList" />
  </Panel>
</template>

<script>
import { mapGetters } from 'vuex';
import { CUSTOMER_LIST_REQUEST } from '@/store/actions/customer';
import Panel from '@/components/ui/Panel';
import Button from '@/components/ui/button/Button';
import CustomerSearchContactsResultModal from '@/components/customer/CustomerSearchContactsResultModal';

export default {
  props: {
    customer: Object,
  },

  data() {
    return {
      modalId: 'search-modal',
    };
  },

  computed: {
    ...mapGetters(['customerList', 'customerMeta', 'customerListStatus', 'getCustomerById']),
    isLoading() {
      return this.customerListStatus === 'loading';
    },
  },

  methods: {
    async onSearch(phone) {
      const payload = {
        filters: {},
        sort: {
          field: 'id',
          type: 'desc',
        },
        page: 1,
        perPage: 20,
      };
      payload.filters['filter[phone]'] = phone;
      await this.$store.dispatch(CUSTOMER_LIST_REQUEST, payload);

      if (this.customerListStatus === 'success' && this.customerList?.length > 0) {
        cash(`#${this.modalId}`).modal('show');
      } else {
        this.$toasted.show(this.$t('toast.noInformationFound'), { type: 'error' });
      }
    },
  },

  components: {
    Panel,
    Button,
    CustomerSearchContactsResultModal,
  },
};
</script>
